import { useEffect, useState } from "react";
import { setUserAppVersion } from "@/api/user";

export type VersionMismatchHandler = (
  remote: string,
  local: string | null
) => void;

export function useVersionCheck(storageKey = "appVersion"): string | null {
  const [remoteVersion, setRemoteVersion] = useState<string | null>(null);

  useEffect(() => {
    async function check() {
      try {
        const res = await fetch("/assets/version.json", { cache: "no-cache" });
        if (!res.ok)
          throw new Error(`Failed to load version.json: ${res.status}`);
        const { version } = (await res.json()) as { version: string };

        setRemoteVersion(version);
        const localVersion = localStorage.getItem(storageKey);

        if (localVersion !== version) {
          await setUserAppVersion({ app_version: version });
          console.log(`Version changed: ${localVersion} → ${version}`);
          window.location.reload();
          localStorage.setItem(storageKey, version);
        }
      } catch (err) {
        console.error("Version check error:", err);
      }
    }

    check();
  }, []);

  return remoteVersion;
}

export function useVersion(storageKey = "appVersion") {
  const [version, setVersion] = useState<string | null>(() =>
    localStorage.getItem(storageKey)
  );

  useEffect(() => {
    setVersion(localStorage.getItem(storageKey));
  }, [storageKey]);

  return version;
}
